<template>
      <div class="right-div" :style='{width:"100%",height:(this.$store.state.windowHeight-153)+"px"}'>
            <div class="common-space-between">
               <div>
                  <div class="common-items-center" style="margin-bottom:10px;">
                     <InputBlock title="工厂名称">
                       <el-input v-model="factoryName" :size="this.$store.state.inputSize" placeholder="请输入工厂名称" onkeyup='value=value.replace(/^\s*|\s*$/g,"")'/>
                     </InputBlock>   
                     <SelectBlock title="所属公司" placeholder="请选择协议所属公司" keyVal="company" ref="company" :options="companyList" :size="this.$store.state.inputSize" width="200" @getVal="getValParms"/>
                  </div>
                  <div class="common-items-center">
                     <InputBlock title="协议名称">
                        <el-input v-model="name" :size="this.$store.state.inputSize" placeholder="请输入工厂名称" onkeyup='value=value.replace(/^\s*|\s*$/g,"")'/>
                     </InputBlock>  
                     <SelectBlock title="协议状态" placeholder="请选择协议状态" keyVal="enabled" ref="enabled" :size="this.$store.state.inputSize" width="200" @getVal="getValParms"/>
                     <el-button type="primary" icon="el-icon-search" :size="this.$store.state.btnSize"  @click="searchBtn">搜索</el-button>
                     <el-button type="danger"  icon="el-icon-refresh" :size="this.$store.state.btnSize"  @click="resetBtn">重置</el-button>
                  </div>
               </div>
               <div class="warp-btn">
                  <el-button type="primary" icon="el-icon-plus" :size="this.$store.state.btnSize"  @click="addBtn">新增</el-button>
               </div>
            </div>
            <div class="warp-table">
                  <el-table ref="giftTable" :data="tableData" :empty-text="this.$store.state.tableEmpty" :size="this.$store.state.tableSize" style="width:100%"  row-key="id"  :height="(this.$store.state.windowHeight-300)">
                  <el-table-column align="center" header-align="center" label="序号"  width="55">
                     <template slot-scope="scope">{{scope.$index+1}}</template>
                  </el-table-column>  
                  <el-table-column  prop="name" :show-overflow-tooltip="true"  label="协议名称"  width="200"></el-table-column>
                  <el-table-column  prop="name" :show-overflow-tooltip="true"  label="使用工厂名称"  width="400">
                     <template slot-scope="scope">
                         <span class="version" v-for="(item,index) in scope.row.protocolFactories" :key="index">
                           {{item.factoryName}} <span v-if="index!=scope.row.protocolFactories.length-1">,</span> 
                        </span>
                     </template>
                  </el-table-column>
                  <el-table-column  prop="company" :show-overflow-tooltip="true" label="协议所属公司" width="300"></el-table-column>
                  <el-table-column  prop="createTime" :show-overflow-tooltip="true" label="版本" width="200">
                     <template slot-scope="scope">
                         <div>
                            <el-tag size="mini" class="version"  v-for="(item,index) in scope.row.protocolVersions" :key="index">{{item.name}}</el-tag>
                         </div>
                     </template>
                  </el-table-column>
                  <el-table-column  prop="operator" :show-overflow-tooltip="true" align="center" header-align="center" label="最近操作人" width="200">
                     <template slot-scope="scope">
                        <div class="common-space-around">
                           <span v-if="!scope.row.operator">--</span>
                           <span v-else>{{scope.row.operator}}</span>
                        </div>
                     </template>
                  </el-table-column>
                  <el-table-column  prop="name"  :show-overflow-tooltip="true" label="更新时间"  width="160">
                     <template slot-scope="scope">
                         <span v-if="!scope.row.modifyTime">{{scope.row.createTime}}</span>
                         <span v-else>{{scope.row.modifyTime}}</span>
                     </template>
                  </el-table-column>
                  <el-table-column  prop="address" :show-overflow-tooltip="true" label="协议状态" width="100" align="center" header-align="center">
                     <template slot-scope="scope">
                        <div class="common-space-around">
                           <span v-if="scope.row.enabled" class="open">正常</span>
                           <span v-else  class="disable">禁用</span>
                        </div>
                     </template>
                  </el-table-column>
                  <el-table-column  prop="address" :show-overflow-tooltip="true" label="操作" fixed="right" width="160" align="center" header-align="center">
                     <template slot-scope="scope">
                        <div class="common-space-around common-items-center operate"> 
                           <el-link  @click="ediBtn(scope.row)" :underline="false" type="primary" >编辑</el-link>
                           <el-link  @click="lookBtn(scope.row)" :underline="false" type="info"  plain>查看</el-link>
                           <!-- <el-link  @click="deleteBtn(scope.row)" :underline="false" type="danger"  >删除</el-link> -->
                           <el-link v-if="!scope.row.enabled" @click="isOpenBtn(scope.row,1)" :underline="false" type="success">启用</el-link>
                           <el-link v-else @click="isOpenBtn(scope.row,0)" :underline="false" type="info">禁用</el-link>
                        </div>
                     </template>
                  </el-table-column>
               </el-table>
               <Paging @getPage="getPage" :total="total" :pageNo="current" :size="size"/>
            </div>
            <AddBlock ref="add" :list="companyList"></AddBlock>
            <EidtBlock ref="eidt" :list="companyList"></EidtBlock>
            <LookBlock ref="look"></LookBlock>
      </div>
  </template>
  <script>
  
  import { scroll } from '@/components/component-mixin/block-scroll'
  import AddBlock from './common-module/protocol-add-block.vue'
  import EidtBlock from './common-module/protocol-eidt-block.vue'
  import LookBlock from './common-module/protocol-look-block.vue'
  import {url,iotApi} from '@/utils/config'
  
  import {postFun,deleteFun,getFun,putFun} from '@/utils/httpFun'
  export default {
    name: 'index',
    mixins: [scroll],
    components:{
        AddBlock:AddBlock,
        EidtBlock:EidtBlock,
        LookBlock:LookBlock
    },
    data:()=>({  
      tableData: [{}],
      unitId:0, 
      form:{
        name:""
      },
      factoryList:[],
      name:null,          //协议面
      enabled:null,
      company:null,       //公司名称
      factoryName:null,   //工厂名称
      companyList:[],      //公司名称
      current:1,
      size:10,
      total:10,    
    }),
    created(){
       this.size = this.$store.state.pageSize
       this.getList()
       this.getFactoryList()
       this.getCompany()
    },
    methods:{
      
      //公司名称
      getCompany(){
         getFun(iotApi.COMPANYLIST,{},res=>{
            console.log("公司名称",res.data) 
            let list = []
            for(var i in res.data){
               list.push({indexNo:i,selectName:res.data[i]})
            }
            this.companyList = list
         })
      }, 
      
      //获取所有的数据
      async getList(){
         let parms={
               param:{
                  isDel:0,   //未删除
                  name:this.name,
                  enabled:this.enabled,
                  company:this.company,
                  factoryName:this.factoryName
               },
            current:this.current,
            size:this.size
        }
        await postFun(iotApi.DEALLIST,parms,res=>{
              console.log(res.data.size)
              this.tableData = res.data.records
              this.total = res.data.total
              this.size = res.data.size
              this.current = res.data.current
        })
      },

      //获取工厂的信息
      async getFactoryList(){
         await getFun(iotApi.DEALFACTORY,{},res=>{
            this.factoryList = res.data
        })
      },
      
      //获取输入的参数
      getValParms(ev){
         console.log(ev)
         if(ev.key=="enabled"){
            this.enabled = ev.indexNo == 1 ? true:false
         }else{
            this[ev.key] = !ev.val ?  ev.selectName :  ev.val
         }
         
      },
      //搜索
      searchBtn(){
         this.getList()
      },

      resetBtn(){
         this.name = null
         this.enabled = null
         this.company = null
         this.factoryName = null
         this.current = 1
         this.$refs.enabled.setVal("")
         this.$refs.company.setVal("")
         this.getList()
      },


  
      //新增协议
      addBtn(){
         this.$refs.add.showBlockMe(this.factoryList);
      },
  
   
      //编辑协议
      ediBtn(ev){
         this.$refs.eidt.showBlockMe(ev,this.factoryList);
      },

      //查看
      lookBtn(ev){
         this.$refs.look.showBlockMe(ev,this.factoryList);
      },
  
      //启用与禁用
      async isOpenBtn(ev,state){
        let parms = {
            id:ev.id,
            enabled:state
        } 
        await putFun(iotApi.DELETEISOPEN,parms,res=>{
           this.getList()
        })
      },

      //删除
      async deleteBtn(ev){
          
         let parms = {
            id:ev.id,
            hasDelete:1
         }
         await putFun(iotApi.DEALDELET,parms,res=>{
            this.getList()
         })
      },
      
      //分页
      getPage(ev){
         this.size = ev.pageSize
         this.current = ev.pageNo 
         this.getList()
      }
    }
  }
  </script>
  <style lang="scss" scoped>
      .right-div{
         padding:15px;
         box-sizing: border-box;
      }
      .version{
         margin-right: 5px;
      }
      .warp-table{
         margin-top: 15px; 
      }
      .operate{
          ::v-deep .el-button--mini{
            padding: 5px 8px;
          }
       }
  </style>
  